import React, { useState } from 'react';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageWithHeader from '../common/PageWithHeader';
import { useAppSelector } from '../../redux/hooks';
import { useRouter } from '../../hooks/useRouter';
import { useGetMyCastingToolsQuery, CastingTool } from '../../redux/castingToolApi';
import LoadingCover from '../common/LoadingCover';

// Read-only Casting Tool display component
const CastingToolDisplay: React.FC<{ castingTool: CastingTool }> = ({ castingTool }) => {
  const colWidths = ['3.45%', '3.45%', '14.84%', '28.24%', '3.44%', '3.44%', '14.86%', '28.28%'];

  const commonTableCell = {
    border: '1.5px solid #231F20',
    padding: '6px 8px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    color: '#231F20',
    verticalAlign: 'middle',
  } as const;

  const numberCell = {
    ...commonTableCell,
    backgroundColor: '#231F20',
    color: '#FFFFFF',
    fontWeight: 700,
    textAlign: 'center',
    fontSize: '18px',
    lineHeight: 1,
    padding: '4px 0',
  } as const;

  const textCellStyle = {
    width: '100%',
    minHeight: 56,
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: 14,
    color: '#231F20',
    padding: '6px 8px',
    boxSizing: 'border-box' as const,
    whiteSpace: 'pre-wrap' as const,
  };

  return (
    <Box sx={{ overflowX: 'auto', border: '1.5px solid #231F20' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', minWidth: 960 }}>
        <colgroup>
          {colWidths.map((width, i) => (
            <col key={i} style={{ width }} />
          ))}
        </colgroup>
        <tbody>
          <tr>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EC7E1E', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>1</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EC7E1E', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>Best Performance: Better</td>
            <td colSpan={4} style={{ ...commonTableCell, backgroundColor: '#8B9B3C', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>2 Best Results: Bigger</td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>1</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#FEEEE0', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Alert</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.alert}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>1</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EDEFE2', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Faster</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.faster}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>2</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#FEEEE0', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Curious</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.curious}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>2</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EDEFE2', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Easier</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.easier}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>3</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#FEEEE0', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Responsive</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.responsive}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>3</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EDEFE2', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Bigger</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.bigger}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>4</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#FEEEE0', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Resourceful</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.resourceful}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>4</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#EDEFE2', fontWeight: 700, fontSize: 28, textAlign: 'center' }}>Better</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.better}</div></td>
          </tr>

          <tr>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#7399B1', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>3</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#7399B1', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>BEING A HERO</td>
            <td colSpan={4} style={{ ...commonTableCell, backgroundColor: '#641833', color: '#FFFFFF', fontWeight: 700, fontSize: 20, textAlign: 'center' }}>
              4 NOT DRIVING OTHERS CRAZY
            </td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>1</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E9EDF2', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>New Commitment</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.newCommitment}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>1</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E6DADB', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>Show Up On Time</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.showUpOnTime}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>2</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E9EDF2', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>New Courage</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.newCourage}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>2</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E6DADB', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>Do What You Say</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.doWhatYouSay}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>3</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E9EDF2', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>New Capability</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.newCapability}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>3</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E6DADB', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>Finish What You Start</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.finishWhatYouStart}</div></td>
          </tr>

          <tr>
            <td style={{ ...numberCell, width: '3.45%' }}>4</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E9EDF2', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>New Confidence</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.newConfidence}</div></td>
            <td style={{ ...numberCell, width: '3.44%' }}>4</td>
            <td colSpan={2} style={{ ...commonTableCell, backgroundColor: '#E6DADB', fontWeight: 700, fontSize: 22, textAlign: 'center' }}>Say Please &amp; Thank You</td>
            <td style={{ ...commonTableCell, backgroundColor: '#FFFFFF' }}><div style={textCellStyle}>{castingTool.entries.sayPleaseThankYou}</div></td>
          </tr>
        </tbody>
      </table>
    </Box>
  );
};

const HistoricCastingTool: React.FC = () => {
  const currentUser = useAppSelector(state => state.auth.user);
  const router = useRouter();
  const { data: historicCastingTools, isLoading, error } = useGetMyCastingToolsQuery();
  const [selectedPeriod, setSelectedPeriod] = useState<string>('');

  if (isLoading) return <LoadingCover />;
  if (error) return <div>Error loading data</div>;

  const handlePeriodChange = (event: SelectChangeEvent) => {
    setSelectedPeriod(event.target.value);
  };

  const selectedCastingTool = historicCastingTools?.find(ct => ct.reviewPeriod === selectedPeriod);

  return (
    <PageWithHeader>
      <Box sx={{ minHeight: '100%', background: '#ECECEC', py: 3 }}>
        <Paper
          elevation={8}
          sx={{
            maxWidth: 1100,
            mx: 'auto',
            p: { xs: 1.5, sm: 2, md: 3 },
            borderRadius: 1.5,
            backgroundColor: '#FFFFFF',
          }}
        >
          <Stack spacing={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton onClick={() => router.push('/reviews/castingtool')} sx={{ border: '1px solid #C9C9C9' }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#123456' }}>
                Your Historic 4x4 Casting Tool Submissions
              </Typography>
            </Box>

            <FormControl variant="outlined" fullWidth required>
              <InputLabel>Review Period</InputLabel>
              <Select
                value={selectedPeriod}
                onChange={handlePeriodChange}
                label="Review Period"
              >
                {historicCastingTools?.map((ct: CastingTool) => (
                  <MenuItem key={ct.reviewPeriod} value={ct.reviewPeriod}>
                    {ct.reviewPeriod}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {!historicCastingTools?.length && (
              <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                You have not submitted any Casting Tool entries yet.
              </Typography>
            )}

            {selectedCastingTool && (
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h5" gutterBottom>
                    Casting Tool for {selectedPeriod}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
                      Name: {currentUser?.name}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
                      Role: {currentUser?.jobTitle}
                    </Typography>
                  </Box>
                </Box>
                <CastingToolDisplay castingTool={selectedCastingTool} />
              </Box>
            )}
          </Stack>
        </Paper>
      </Box>
    </PageWithHeader>
  );
};

export default HistoricCastingTool;
